import styled from 'styled-components';
import Image from '../../../Images/Greeter/bg-2.jpg';

export const GreetContainer = styled.div`
background: #F0FFE6;
width: 100%;
`;

export const GreetWrapper = styled.div`
display: flex;
flex-direction: column;
width: 100%;
max-width: 1400px;
margin-left: auto;
margin-right: auto;
padding: 0 25px;
`;

export const GreetTextWrapper = styled.div`
margin-top: auto;
margin-bottom: auto;
`;

export const GreeterBg = styled.div`
display: flex;
flex-direction: column;
width: 100%;
padding: 100px 0;
background: linear-gradient( rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.2) ), url(${Image});
background-repeat: no-repeat;
background-size: cover;
`;

export const NameGreet = styled.h1`
font-size: 48px;
color: #fff;
text-align: center;

@media screen and (max-width: 768px){
    font-size: 36px;
}

@media screen and (max-width: 480px){
    font-size: 24px;
}
`;

export const GreetInfo = styled.h3`
font-size: 18px;
color: #fff;
text-align: center;
padding: 5px 15px;

@media screen and (max-width: 768px){
    font-size: 14px;
}

@media screen and (max-width: 480px){
    font-size: 12px;
}
`;

export const GreetInfo2 = styled.p`
font-size: 18px;
margin-top: 50px;
color: #003d01;

@media screen and (max-width: 768px){
    font-size: 14px;
}

@media screen and (max-width: 480px){
    font-size: 12px;
}
`;
